import { render, staticRenderFns } from "./DunningOnboardInitial.vue?vue&type=template&id=5f760675&"
import script from "./DunningOnboardInitial.vue?vue&type=script&lang=js&"
export * from "./DunningOnboardInitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports